import React from 'react';
import { BonusCard } from './BonusCard';
export function BonusFour() {
  return <BonusCard number={4} title="Tracker de Noches en Calma" value="$39 USD" imageSrc="https://cdn.magicpatterns.com/uploads/cHn5KVnczAWsGvJoR78JXy/Gemini_Generated_Image_u6vjigu6vjigu6vj.jpg" imageAlt="Tracker de Noches en Calma" copy="Este tracker convierte noches confusas en progreso visible. Mide tu avance de forma simple para reforzar tu consistencia y motivación. En lugar de sentir que todo depende del azar, podrás ver tus mejoras reales, ajustar tu rutina y sostener el impulso hacia el silencio total con más confianza cada día." bullets={[{
    title: 'Tracker de 14 días',
    description: 'Para volver el método un hábito sólido e inquebrantable.'
  }, {
    title: 'Indicadores de Progreso Real',
    description: 'Qué medir exactamente (no busques perfección, busca menos lucha mental).'
  }, {
    title: 'Hoja de Observaciones Rápidas',
    description: 'Detecta qué te ayuda más y qué te activa para hacer ajustes.'
  }]} deliverables={['Tracker PDF 14 días', 'Printable y móvil editable', 'Mini guía de uso']} data-id="element-69" />;
}